<template>
    <div id="page-branch-list">
        <div class="vx-card p-6">
            <div class="vx-row">
                <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-full w-full">
                    <h3>Danh sách khách hàng</h3>
                </div>
            </div>

            <div class="vx-row">
                <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full mt-4">
                    <label class="vs-input--label">Chi nhánh</label>
                    <v-select class="w-full" v-model="selectedBranch" :options="branchOptions" :clearable="false"
                              name="branch">
                        <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                    </v-select>
                </div>
                <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full mt-4">
                    <label class="vs-input--label">Trạng thái</label>
                    <v-select class="w-full" v-model="selectedEnabled" :options="statusOptions" :clearable="false"
                              name="status">
                        <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                    </v-select>
                </div>
                <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full mt-4">
                    <label class="vs-input--label">Tìm kiếm</label>
                    <vs-input class="w-full" v-model="searchQuery" :placeholder="$t('button.search')"/>
                </div>
                <div class="vx-col lg:w-1/4 md:w-1/3 w-full mt-4">
                    <vs-button class="float-left lg:mt-6 md:mt-6" color="primary" icon-pack="feather" icon="icon-search"
                               @click="findCustomerData">Tìm
                        kiếm
                    </vs-button>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col w-full">
                    <div class="flex flex-wrap">
                        <vs-button class="mr-2 mt-6" @click="addCustomer" color="primary" icon-pack="feather"
                                   icon="icon-plus">
                            {{ $t('menuCustomer.addCustomer') }}
                        </vs-button>
                        <vs-button class="mr-2 mt-6" iconPack="feather" color="primary" icon="icon-download"
                                   @click="downloadFile">Tải xuống tệp mẫu
                        </vs-button>
                        <vs-button class="mr-2 mt-6" iconPack="feather" color="primary" icon="icon-upload"
                                   @click="$refs.fileUpload.click()">Tải lên tệp khách
                        </vs-button>
                        <input ref="fileUpload" type="file" id="fileUpload" accept=".xlsx, .xls, .csv, .xlsm, .xlsb"
                               class="hidden" @change="uploadFile($event)">
                    </div>
                </div>
            </div>
            <!-- AgGrid Table -->
            <ag-grid-vue style="height: 55vh" ref="agGridTable" :components="components" :gridOptions="gridOptions"
                         class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         :rowData="customerData" :animateRows="true"
                         :localeText="{ noRowsToShow: this.$t('menuCustomer.noRowsToShow') }"
                         :paginationPageSize="paginationPageSize" :onGridReady="onGridReady"
                         :autoSizeStrategy="autoSizeStrategy">
            </ag-grid-vue>

            <div class="vx-row" v-if="customerData.length > 0">
                <div class="vx-col md:w-1/2">
                    <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">
                        <span class="vx-col mt-2">Số phần tử / trang:</span>
                        <vs-dropdown vs-trigger-click class="cursor-pointer">
                            <div
                                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                                <span class="mr-2">
                                    {{
                                        customerData.length - currentPage * pageSize > 0 ? currentPage *
                                            pageSize
                                            : customerData.length
                                    }} /
                                    {{ totalElements }}</span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                            </div>
                            <vs-dropdown-menu>

                                <vs-dropdown-item @click="changePageSize(10)">
                                    <span>10</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSize(15)">
                                    <span>15</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSize(20)">
                                    <span>20</span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                    <vs-pagination :total="totalPages" v-model="currentPage" @change="loadPageCustomer"/>
                </div>
            </div>
        </div>

        <vs-popup class="holamundo popupError" title="Lỗi tải lên tệp khách hàng" :active.sync="popupErrorImport">
            <div class="">
                <div>
                    <vs-table stripe :data="errorData" noDataText="Không có dữ liệu" pagination max-items="5">
                        <template slot="thead">
                            <vs-th> STT</vs-th>
                            <vs-th> Trường dữ liệu</vs-th>
                            <vs-th> Hàng</vs-th>
                            <vs-th> Cột</vs-th>
                            <vs-th> Lỗi</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(item, indextr) in data">
                                <vs-td> {{ item.stt }}</vs-td>

                                <vs-td> {{ item.header }}</vs-td>

                                <vs-td> {{ item.rowNumError }}</vs-td>

                                <vs-td> {{ item.colChar }}</vs-td>

                                <vs-td> {{ item.message }}</vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import {AgGridVue} from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import moment from "moment";
import authConfig from '@/../auth_config.json';

export default {
    components: {
        AgGridVue,
        vSelect,
        // Cell Renderer
        CellRendererActions,
    },
    data() {
        return {
            searchQuery: "",
            // maxPageNumbers: 7,
            // AgGrid
            gridApi: null,
            gridOptions: {},
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: this.$t('menuCustomer.stt'),
                    field: 'stt',
                    width: 100
                },
                {
                    headerName: this.$t('menuCustomer.customerName'),
                    field: 'fullName',
                    width: 200
                },
                {
                    headerName: this.$t('menuCustomer.phoneNumber'),
                    field: 'phoneNumber',
                    width: 150,
                },
                {
                    headerName: 'Số thẻ',
                    field: 'cardNumber',
                    width: 150,
                },
                {
                    headerName: 'Điểm thưởng',
                    field: 'points',
                    width: 150,
                },
                {
                    headerName: this.$t('menuCustomer.dateCreated'),
                    field: 'created_at_display',
                    width: 150,
                },
                {
                    headerName: this.$t('button.actions'),
                    field: 'actions',
                    width: 150,
                    cellRenderer: 'CellRendererActions',
                    suppressSizeToFit: true,
                },
            ],
            // Cell Renderer Components
            components: {
                CellRendererActions,
            },
            customerData: [],
            // customerTypes: [
            //     {value: null, label: this.$t('menuCustomer.all'), valueNumber: null},
            //     { value: "customer", label: this.$t('cardCustomer.customer'), valueNumber: 0 },
            //     { value: "guest", label: this.$t('cardCustomer.passers'), valueNumber: 1 },
            // ],
            pageNumber: 0,
            pageSize: 20,
            totalPages: 0,
            currentPage: 1,
            listCards: [],
            branchOptions: [],
            selectedBranchValue: null,
            files: null,
            totalElements: 0,
            statusOptions: [
                {value: null, label: 'Tất cả'},
                {value: true, label: 'Hoạt động'},
                {value: false, label: 'Ngừng hoạt dộng'},
            ],
            selectedEnabledValue: null,
            popupErrorImport: false,
            errorData: [],
            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
        }
    },
    async created() {
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.filter(el => el.organizationBranchType !== 3).map(x => {
            return {label: x.organizationBranchName, value: x.id}
        });

        this.branchOptions.unshift({value: null, label: 'Tất cả'})
        this.findCustomerData();
    },
    watch: {
        '$store.state.windowWidth'(val) {
            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.isUpdateVipCustomer'(val) {
            if (val) {
                this.findCustomerData();
                this.$store.commit('UPDATE_VIP_CUSTOMER', false);
            }
        }
    },
    computed: {
        paginationPageSize() {
            if (this.gridApi) return this.gridApi.paginationGetPageSize();
            else return 20
        },
        selectedBranch: {
            get() {
                let obj = this.branchOptions.find(x => x.value === this.selectedBranchValue);
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedBranchValue = obj ? obj.value : null;
            }
        },
        selectedEnabled: {
            get() {
                let obj = this.statusOptions.find(x => x.value === this.selectedEnabledValue);
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedEnabledValue = obj ? obj.value : null;
            }
        }
    },
    methods: {
        updateSearchQuery(val) {
            this.gridApi.setQuickFilter(val)
        },

        addCustomer() {
            this.$router.push(`/user/add-customer`).catch(() => {
            });
        },

        onGridReady() {
            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },

        findCustomerData() {
            const payload = {};
            payload['pageNumber'] = this.pageNumber;

            if (this.selectedBranchValue) payload['organizationBranchId'] = this.selectedBranchValue;
            if (this.searchQuery) payload['keySearch'] = this.searchQuery;
            if (this.pageSize) payload['pageSize'] = this.pageSize;
            if (this.selectedEnabledValue || this.selectedEnabledValue === false) payload['enabled'] = this.selectedEnabledValue;

            const params = new URLSearchParams(payload).toString();
            this.$vs.loading();
            this.$crm.get(`/loyalty/customer/find?${params}`).then(response => {
                if (response.data.content && response.data.content.length > 0) {
                    this.customerData = response.data.content.map(t => {
                        t.stt = this.pageSize * this.pageNumber + response.data.content.indexOf(t) + 1;
                        t.created_at_display = t.createdDate ? moment(t.createdDate).format("DD/MM/YYYY HH:mm:ss") : null;
                        t.cardNumber = t.card ? t.card.number : null;
                        t.points = t.card ? t.card.points : null;
                        return t;
                    })
                } else {
                    this.customerData = [];
                }

                this.totalPages = response.data.totalPages;
                this.totalElements = response.data.totalElements;
                this.$vs.loading.close();
                setTimeout(() => {
                    if (this.$store.state.windowWidth > 1024) {
                        this.gridApi.sizeColumnsToFit();
                    }
                }, 100);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        loadPageCustomer: function (currentPage) {
            this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
            this.findCustomerData();
        },

        changePageSize(number) {
            this.pageSize = number;
            this.findCustomerData();
        },

        downloadFile() {
            this.$vs.loading();
            this.$crm.post('/loyalty/customer/download-template-customer').then(res => {
                window.open(authConfig.crmDomain + "file/beauty/" + res.data.data + "?access_token=" + localStorage.getItem("access_token"), "_blank");
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        isExcel(file) {
            return /\.(xlsx|xls|csv|xlsm|xlsb)$/.test(file.name)
        },

        uploadFile(e) {
            if (!this.selectedBranchValue) {
                this.$refs.fileUpload.value = null;
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: 'Hãy chọn chi nhánh cần thêm lên khách hàng trước khi tải tệp lên!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                })
            }
            let file = [...e.target.files];
            if (!this.isExcel(file[0])) {
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: 'Chỉ hỗ trợ tệp có định dạng .xlsx, .xls, .csv, .xlsm, .xlsb',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                })
            }

            let formData = new FormData();
            formData.append('files', file[0]);
            this.errorData = [];
            this.$vs.loading();
            this.$crm.post('/loyalty/customer/import-excel', formData).then(res => {
                if (res.data.data && res.data.data.length > 0) {
                    this.popupErrorImport = true;
                    this.errorData = res.data.data.map(el => {
                        el.stt = res.data.data.indexOf(el) + 1;
                        return el;
                    });
                } else {
                    this.findCustomerData();
                }
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });

            this.$refs.fileUpload.value = null;
        }
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
    },
}
</script>

<style>
.popupError .vs-popup--header {
    background: rgba(var(--vs-danger), 1) !important;;
}
</style>
